import { css } from '@emotion/react';

export const appStyle = css({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});
